import React, { useEffect, useState } from "react";
import { geetingNameListModel, geetingOpenAIModels, GettingAllModels } from "../../../allApi/api";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  FormControl,
  HStack,
  Select,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { waveflowModelList } from "../../../redux/reducer/waveFlow";
import TokenLimitDropdown from "./PoverProp";
import { commonStyle } from "../../../styles/commonStyle";

function DetailsModal({ formData, setFormData, errorset }) {
  const [loader, setloader] = useState(true);
  const [modelnameList, setmodelnameList] = useState([]);
  const [modelodelNameLoader, setModelNameLoader] = useState(false);

  const waveflowModelAdd = useSelector(
    (state) => state?.waveflowSearchData?.waveflowModal
  );
  const waveFlowDelete = useSelector(
    (state) => state?.waveflowSearchData?.waveFlowDelete
  );
  const dispatch = useDispatch();
  const [modelList, setModelList] = useState([]);
  const [filterlist, setFilterList] = useState([]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name == "model") {
      setmodelnameList("");
      setFormData({
        ...formData,
        model: "",
      });
      if (value == "together") {
        try {
          setModelNameLoader(true);
          const dataOfModel = await geetingNameListModel("together");
          setmodelnameList(dataOfModel);
        } catch (error) {
          throw new Error("Together model api :", error);
        } finally {
          setModelNameLoader(false);
        }
        setFormData((prev) => ({
          ...prev,
          base_url: "https://api.together.xyz/v1",
        }));
      }
      if (value == "groq") {
        try {
          setModelNameLoader(true);
          const dataOfModel = await geetingNameListModel("groq");
          setmodelnameList(dataOfModel);
        } catch (error) {
          throw new Error("groq model api :", error);
        } finally {
          setModelNameLoader(false);
        }
        setFormData((prev) => ({
          ...prev,
          base_url: "https://api.groq.com/openai/v1",
        }));
      }
      if (value == "openai") {
        try {
          setModelNameLoader(true);
          const dataOfModel = await geetingOpenAIModels();
          if (dataOfModel && dataOfModel.length > 0) {
            setmodelnameList(dataOfModel);
          }
        } catch (error) {
          console.error("OpenAI model fetch error", error);
        } finally {
          setModelNameLoader(false);
        }
        setFormData((prev) => ({
          ...prev,
          base_url: "https://api.openai.com/v1/",
        }));
      }
      if (value == "mistral") {
        setFormData((prev) => ({
          ...prev,
          base_url: "",
        }));
      }
      if (value == "deepseek") {
        setFormData((prev) => ({
          ...prev,
          base_url: "https://api.deepseek.com/v1",
        }));
      }
      if (value == "gemini") {
        try {
          setModelNameLoader(true);
          const dataOfModel = await geetingNameListModel("gemini");
          setmodelnameList(dataOfModel);
        } catch (error) {
          throw new Error("Together model api :", error);
        } finally {
          setModelNameLoader(false);
        }
        setFormData((prev) => ({
          ...prev,
          base_url: "https://generativelanguage.googleapis.com/v1beta/openai/",
        }));
      }
      const selectedModel =
        modelList?.find((item) => item?.client === value) || null;
      setFormData((prev) => ({ ...prev, [name]: selectedModel }));
    }
    if (name == "model_data") {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (name == "selected_model") {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await GettingAllModels();
        setModelList(data?.models);
        setFilterList(data?.models);
      } catch (error) {
        console.error("Error fetching models:", error);
      } finally {
        setloader(false);
      }
    };
    fetchData();
  }, [waveflowModelAdd, waveFlowDelete]);

  return (
    <Box p={2}>
      <FormControl mb={0} isRequired>
        <HStack>
          <VStack width={"30%"} gap={0}>
            <Select
              mb={0}
              name="model"
              fontSize="14px"
              value={formData?.model}
              onChange={handleChange}
              width="100%"
              bg={"gray.200"}
              size={"xs"}
              isRequired
            >
              <option isDisabled hidden value={""}>
                {formData?.model?.client || "Select client"}
              </option>
              {modelList &&
                modelList.map((ele) => (
                  <option value={ele?.client}>{ele?.client} </option>
                ))}
            </Select>
            {errorset?.model && (
              <Text color={"red"} fontSize={"12px"}>
                {errorset?.model}
              </Text>
            )}
          </VStack>
          {modelodelNameLoader ? (
            <Spinner />
          ) : (
            <VStack gap={0} w={"30%"}>
              <Select
                w={"100%"}
                _placeholder={{
                  opacity: 0.2,
                  color: "rgba(108, 114, 117, 0.75)",
                }}
                value={formData?.selected_model}
                onChange={handleChange}
                name="selected_model"
                size={"xs"}
                maxH="30vh"
                overflowY="auto"
                sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
              >
                <option isDisabled hidden value={""}>
                  {formData?.selected_model || "Select Model"}
                </option>
                {modelnameList &&
                  modelnameList.map((model, index) => (
                    <option value={model}>{model}</option>
                  ))}
              </Select>
              {errorset?.selected_model && (
                <Text color={"red"} fontSize={"12px"}>
                  {errorset?.selected_model}
                </Text>
              )}
            </VStack>
          )}
        </HStack>
        <HStack>
          <TokenLimitDropdown
            desc={
              "The maximum number of tokens to process / generate in the completion.The token count of your prompt plus token limit cannot exceed the model's maximum context length of 128000 tokens."
            }
            defaultvalue={formData?.tokens || 512}
            min={100}
            max={1024}
            title={"Token Limit"}
            formData={formData}
            setFormData={setFormData}
            name="tokens"
          />
          <TokenLimitDropdown
            desc={
              "The sampling temperature to use. Higher values like 0.9 will make the output more random, while lower values like 0.2 will make it more focused and deterministic."
            }
            defaultvalue={formData?.temperature || 0.7}
            min={0}
            max={1}
            title={"Temperature"}
            formData={formData}
            setFormData={setFormData}
            name="temperature"
          />
          <TokenLimitDropdown
            desc={
              "An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered."
            }
            defaultvalue={formData?.top_p || 0.7}
            min={0}
            max={1}
            title={"Top P"}
            formData={formData}
            setFormData={setFormData}
            name="top_p"
          />
        </HStack>
      </FormControl>
    </Box>
  );
}

export default DetailsModal;
